export default "<mat-spinner mode=\"indeterminate\"></mat-spinner>";